module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.a5335d78.webp";